export default function moderationMails(availableRecipients) {
  return {
    recipients: [],
    recipientsOpen: false,
    availableRecipients: availableRecipients,
    visibleRecipients: availableRecipients,
    query: '',

    init() {
      // Close the recipients dropdown when the TinyMCE editor is clicked
      document.addEventListener('tinyMceClicked', () => {
        this.$refs.recipientsDetails.open = false;
      });

      this.$watch(
        () => this.recipientsOpen,
        (isOpen) => {
          this.$refs.recipients.focus();
        }
      );
    },

    handleTemplateSelectionChange(templateId) {
      const selectedTemplate = document.querySelector(`#template-${templateId}`).content.cloneNode(true);

      this.setEditorContent(selectedTemplate);
      this.setRecipients(selectedTemplate);
      this.setSubject(selectedTemplate);
    },

    setEditorContent(selectedTemplate) {
      const content = selectedTemplate.querySelector(`#template-body`).textContent;
      this.$refs.editor && tinymce.get(this.$refs.editor.id).setContent(content);
    },

    setRecipients(selectedTemplate) {
      const recipients = selectedTemplate.querySelector(`#template-recipients`).textContent;
      this.addNewRecipients(recipients);
    },

    setSubject(selectedTemplate) {
      const subject = selectedTemplate.querySelector(`#template-subject`).innerHTML;
      this.$refs.subject.value = subject;
    },

    toggleRecipient(el) {
      const email = el.value;
      let recipients = Array.from(new Set([...this.recipients, email]));
      if (!el.checked) recipients = recipients.filter((r) => r !== email);
      this.recipients = recipients;
      this.clearNewRecipients();
    },

    filterRecipients() {
      this.visibleRecipients = this.availableRecipients.filter((mail) =>
        mail.toLowerCase().includes(this.query.toLowerCase())
      );
    },

    addNewRecipients(recipients = '') {
      let newRecipients = recipients.split(',').map((recipient) => recipient.trim());
      recipients = [...this.recipients, ...newRecipients].filter((recipient) => recipient);
      this.recipients = [...new Set(recipients)];
      this.clearNewRecipients();
    },

    clearNewRecipients() {
      this.query = '';
      this.visibleRecipients = [...this.availableRecipients];
      this.$refs.recipients.focus();
    },

    clearRecipients() {
      this.recipients = [];
      this.$refs.recipients.focus();
    },
  };
}
